import React from 'react';

import type * as api from '@gitbook/api-client';
import { translationLanguageDescriptors } from '@gitbook/app-translations';
import { Button, DialogRoot, DialogTrigger, Emoji } from '@gitbook/spine-react';

import { getSiteSpaceSiblingsInSiteStructure } from '../../Organization';
import { EditSpaceLanguageDialog } from '../../Space';

/**
 * Button to edit the language of a site variant space.
 * We only display the button if the site space should be considered a language variant.
 */
export function SiteVariantLanguageButton(props: {
    siteStructure: api.SiteStructure;
    siteSpace: api.SiteSpace;
}) {
    const { siteStructure, siteSpace } = props;
    const { space } = siteSpace;

    const isLanguageVariant = React.useMemo(() => {
        const siblings = getSiteSpaceSiblingsInSiteStructure(siteStructure, siteSpace.id);
        return siblings.some((sibling) => {
            return (
                Boolean(sibling.space.language) &&
                sibling.space.language !== siteSpace.space.language
            );
        });
    }, [siteStructure, siteSpace]);

    if (!space?.language || !isLanguageVariant) {
        return null;
    }

    return (
        <DialogRoot>
            <DialogTrigger>
                <Button
                    label="Edit language"
                    tooltip={{
                        label: `${translationLanguageDescriptors[space.language].label}`,
                        description: 'Edit the language of the space',
                    }}
                    kind="blank"
                    size="small"
                    iconOnly
                    leadingIcon={
                        <Emoji code={translationLanguageDescriptors[space.language].emoji} />
                    }
                />
            </DialogTrigger>
            <EditSpaceLanguageDialog space={space} />
        </DialogRoot>
    );
}
